import React, { useState, useEffect } from 'react';
import { Button, Modal, Spinner } from "react-bootstrap";
import { Add, DeleteForever, LinkTwoTone, Videocam, PictureAsPdf } from '@material-ui/icons';

import incident_manager from '../api/incident'

const IncidentMedicalLinkPopup = ({ incidentId, visible, hidePopup, generateCallback }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [incidentLinks, setIncidentLinks] = useState([]);
    const [copiedIndex, setCopiedIndex] = useState(null);
    const [selectedRecipients, setSelectedRecipients] = useState(new Set());

    const allSelected = incidentLinks.length > 0 && incidentLinks.every(link =>
        selectedRecipients.has(link.recipient_id)
    );

    useEffect(async () => {
        if (visible) {
            setIsLoading(true);
            const links = await generateCallback();
            setIncidentLinks(links)
            setIsLoading(false);
            setSelectedRecipients(new Set());
        }
    }, [visible]);

    const toggleRecipient = (recipientId) => {
        setSelectedRecipients(prev => {
            const next = new Set(prev);
            next.has(recipientId) ? next.delete(recipientId) : next.add(recipientId);
            return next;
        });
    };

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedRecipients(new Set());
        } else {
            setSelectedRecipients(
                new Set(incidentLinks.map(l => l.recipient_id))
            );
        }
    };

    const handleSubmitSendEmail = () => {
        const recipientIds = Array.from(selectedRecipients);

        const result = incident_manager.generate_send_qualtrics_links(incidentId, recipientIds);
        if (!result) {
            alert("Error sending survey emails.");
            return;
        }

        alert("Survey emails sent successfully.");

        setSelectedRecipients(new Set());
        hidePopup();
    }

    return (
        <Modal show={visible} onHide={hidePopup}>
            <Modal.Header closeButton>
                <Modal.Title>Qualtrics survey URLs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    { isLoading
                    ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    )
                    : (
                        <>
                            {incidentLinks.length > 0 ? (
                            <>
                            <table className="table table-striped table-sm">
                                <thead>
                                <tr>
                                    <th className='text-center' style={{ width: '40px' }}>
                                        <input
                                            type="checkbox"
                                            checked={allSelected}
                                            onChange={toggleSelectAll}
                                        />
                                    </th>
                                    <th>Recipient</th>
                                    <th>Link</th>
                                </tr>
                                </thead>
                                <tbody>
                                {incidentLinks.map((link, idx) => (
                                    <tr key={link.recipient_id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRecipients.has(link.recipient_id)}
                                                onChange={() => toggleRecipient(link.recipient_id)}
                                            />
                                        </td>
                                        <td>{link.recipient}</td>
                                        <td>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(link.url)
                                                    setCopiedIndex(idx);
                                                    setTimeout(() => setCopiedIndex(null), 2500);
                                                }}
                                            >
                                                {copiedIndex === idx ? "Copied!" : "Copy Link"}
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-start mt-3">
                                <Button
                                    variant="primary"
                                    disabled={selectedRecipients.size === 0}
                                    onClick={handleSubmitSendEmail}
                                >
                                    Send survey email ({selectedRecipients.size})
                                </Button>
                            </div>
                            </>
                            ) : (
                            <p>No links available.</p>
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>    
    );
}

const IncidentMedicalInfo = ({ incidentId }) => {
    let [popupVisible, setPopupVisible] = useState(false)

    return (
        <>
            <h3 key='medicalInfo'>Medical surveillance</h3>
            <div className='newIncidentMediaContainer' style={{marginBottom: 30}}>
                <span className='btn btn-success' onClick={()=>setPopupVisible(true)}><Add/>Generate Qualtrics URLs</span>
                <IncidentMedicalLinkPopup
                    incidentId={incidentId}
                    hidePopup={() => setPopupVisible(false)} 
                    visible={popupVisible} 
                    generateCallback={() => incident_manager.generate_qualtrics_links(incidentId)}
                />
            </div>
        </>
    );
}

export default IncidentMedicalInfo;